var map = {
  "./audiowide.css": [
    "38537",
    [
      2258
    ]
  ],
  "./newrocker.css": [
    "209038",
    [
      8771
    ]
  ],
  "./baloo.css": [
    "461601",
    [
      6986
    ]
  ],
  "./pixelify.css": [
    "746590",
    [
      963
    ]
  ],
  "./bungee.css": [
    "932716",
    [
      5469
    ]
  ],
  "./pacifico.css": [
    "652496",
    [
      7769
    ]
  ],
  "./playpen.css": [
    "487721",
    [
      4386
    ]
  ],
  "./pressstart.css": [
    "607655",
    [
      1212
    ]
  ],
  "./righteous.css": [
    "539660",
    [
      2765
    ]
  ],
  "./vt323.css": [
    "20482",
    [
      6895
    ]
  ],
  "./caveat.css": [
    "276656",
    [
      2761
    ]
  ],
  "./grenze.css": [
    "330777",
    [
      4802
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__(id); });
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 373550;
module.exports = __rspack_async_context;
